import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withModifiers as _withModifiers, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "recharge-page-content"
};
var _hoisted_2 = {
  class: "panel recharge-item-panel"
};
var _hoisted_3 = {
  class: "header"
};
var _hoisted_4 = {
  class: "item-list"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "name"
};
var _hoisted_7 = {
  class: "award"
};
var _hoisted_8 = {
  class: "text van-ellipsis"
};
var _hoisted_9 = {
  class: "desc"
};
var _hoisted_10 = {
  class: "title"
};
var _hoisted_11 = {
  class: "value"
};
var _hoisted_12 = {
  class: "panel"
};
var _hoisted_13 = {
  class: "header"
};
var _hoisted_14 = {
  class: "panel-content"
};
var _hoisted_15 = {
  class: "recharge-footer"
};
var _hoisted_16 = {
  class: "recharge-cur"
};
var _hoisted_17 = {
  class: "key"
};
var _hoisted_18 = {
  class: "value"
};
import { ref, onMounted, computed } from "vue";
import { priceUtil } from "@op/shared";
import RechargeRuleRewardPopup from "./components/RechargeRuleRewardPopup";
import PaymentMethodVue from "@/components/order/PaymentMethod.vue";
import Common from "@/components/dialog/src/Common.vue";
import { showLoading, hideLoading } from "@/utils/loadingUtil";
import { showToast } from "@/utils/toastUtil";
import { Notify } from "@/utils/notifyUtil";
import { queryRechargeRuleList, getRechargeSetting, createRechargeOrder, createRechargeOnlinePayment, checkRechargeOrder } from "@/api/user";
import { SHOP_UNSUPPORT_DELIVERY, SHOP_BUSY, SHOP_NOT_IN_BUSINESS_STATUS, DISHES_ORDER_ITEM_INVALID } from "@/constant/responseCode";
import { useRoute } from "vue-router";
import { useShopStoreWithOut } from "@/store/shopStore";
import { submitPaymentsHub } from "@/utils/paymentsHubUtil";
import { useRouter } from "@/hooks/useRouter";
import { useUserStore } from "@/store/userStore";
import { useCartStore } from "@/store/cartStore";
import { createOnlinePay } from "@op/shared";
import Dialog from "@/components/dialog/dialog";
import { useI18n } from "vue-i18n";
export default {
  __name: 'Recharge',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    // import { useAddressStoreWithOut } from "@/store/addressStore";
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush;
    var routes = useRoute();
    var userStore = useUserStore();
    var shopStore = useShopStoreWithOut();
    var cartStore = useCartStore();
    // const addressStore = useAddressStoreWithOut();
    // const selectedAddress = computed(() => addressStore.getSelectedAddress);
    var paymentMethodRef = ref();
    var deliveryMethod = computed(function () {
      return userStore.getOrderType;
    });
    var recordId = computed(function () {
      return routes.query.id;
    });
    var redirectType = computed(function () {
      return routes.query.redirect;
    });
    var redirectStr = computed(function () {
      if (redirectType.value === "order_detail") {
        return "&redirect=order_detail&order_id=".concat(routes.query.order_id);
      } else if (redirectType.value === "confirm_order") {
        return "&redirect=confirm_order";
      } else {
        return "&redirect=my_balance";
      }
    });
    var rechargeRuleList = ref([]);
    var curSelectedRule = ref("");
    var ruleDesc = ref("");
    var ruleDescShow = computed(function () {
      return ruleDesc.value || t("ruleDescShowDefault");
    });
    var isSubmitButtonDisabled = computed(function () {
      var _paymentMethodRef$val;
      return ((_paymentMethodRef$val = paymentMethodRef.value) === null || _paymentMethodRef$val === void 0 ? void 0 : _paymentMethodRef$val.onlinePaymentOptions.length) <= 0;
    });
    var submitButtonText = computed(function () {
      var _paymentMethodRef$val2;
      if (((_paymentMethodRef$val2 = paymentMethodRef.value) === null || _paymentMethodRef$val2 === void 0 ? void 0 : _paymentMethodRef$val2.onlinePaymentOptions.length) > 0) {
        return t("reload");
      } else {
        return t("pleaseReloadAtTheCashier");
      }
    });
    var queryRule = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var isShowLoading,
          _yield$Promise$all,
          _yield$Promise$all2,
          res,
          descRes,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isShowLoading = _args.length > 0 && _args[0] !== undefined ? _args[0] : true;
              if (isShowLoading) {
                showLoading();
              }
              _context.next = 4;
              return Promise.all([queryRechargeRuleList({
                shop_id: shopStore.getShopId
              }), getRechargeSetting()]);
            case 4:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              res = _yield$Promise$all2[0];
              descRes = _yield$Promise$all2[1];
              if (res.isOK && res.data) {
                rechargeRuleList.value = res.data.items;
              }
              if (descRes.isOK && descRes.data) {
                ruleDesc.value = descRes.data.description;
              }
              if (isShowLoading) {
                hideLoading();
              }
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function queryRule() {
        return _ref.apply(this, arguments);
      };
    }();
    var getRuleRewardStr = function getRuleRewardStr(rule) {
      var _rule$reward_items;
      var resultArr = [];
      (_rule$reward_items = rule.reward_items) === null || _rule$reward_items === void 0 || _rule$reward_items.forEach(function (item) {
        if (item.type === "coupon") {
          resultArr.push("".concat(item.resource_name, " x").concat(item.quantity));
        } else {
          resultArr.push(priceUtil.formatBaseUnitToShowPrice(item.amount, rule.currency, true, 0));
        }
      });
      return resultArr.length ? t("free") + resultArr.join(", ") : "";
    };
    var getIsRuleCanViewDetail = function getIsRuleCanViewDetail(rule) {
      var _rule$reward_items2;
      var couponList = ((_rule$reward_items2 = rule.reward_items) === null || _rule$reward_items2 === void 0 ? void 0 : _rule$reward_items2.filter(function (item) {
        return item.type === "coupon";
      })) || [];
      return couponList.length > 0;
    };
    var handleSelectRechargeRule = function handleSelectRechargeRule(rule) {
      curSelectedRule.value = rule;
    };
    var isRechargeRuleRewardPopupShow = ref(false);
    var viewDetailRewardList = ref([]);
    var viewDetailCurrency = ref("");
    var handleCallRewardDetail = function handleCallRewardDetail(rule) {
      isRechargeRuleRewardPopupShow.value = true;
      viewDetailRewardList.value = rule.reward_items || [];
      viewDetailCurrency.value = rule.currency || "";
    };
    var paymentMethod = ref(null);
    function handleSelectPaymentMethod(val) {
      paymentMethod.value = val;
    }

    // 支付相关
    var isSubmit = ref(false);
    function handleShowOrderFailTips(msg) {
      Dialog.confirm({
        title: t("cannotSubmitOrder"),
        desc: msg,
        okText: t("gotIt"),
        withoutCancel: true
      });
    }
    function handleRecharge() {
      return _handleRecharge.apply(this, arguments);
    } // 检查是否支付成功相关
    function _handleRecharge() {
      _handleRecharge = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var params, result, _paymentMethodValue$s, _paymentMethodValue$s2, _paymentMethodValue$c, _paymentMethodValue$c2, paymentMethodValue, success_url, cancel_url, successUrl, cancelUrl, _result$data, failDishesStr;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!isSubmit.value) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              if (curSelectedRule.value) {
                _context3.next = 5;
                break;
              }
              showToast(t("aReloadAmountMustBeSelected"));
              return _context3.abrupt("return");
            case 5:
              isSubmit.value = true;
              params = {
                amount: curSelectedRule.value.amount,
                currency: curSelectedRule.value.currency,
                shop_id: shopStore.getShopId,
                rule_id: curSelectedRule.value.id
              }; // 参考ConfirmOrder中的线上支付逻辑
              showLoading();
              _context3.prev = 8;
              _context3.next = 11;
              return createRechargeOrder(params);
            case 11:
              result = _context3.sent;
              if (result.isOK && result.data) {
                paymentMethodValue = paymentMethod.value; // 创建支付单
                success_url = (_paymentMethodValue$s = (_paymentMethodValue$s2 = paymentMethodValue.success_url) === null || _paymentMethodValue$s2 === void 0 ? void 0 : _paymentMethodValue$s2.replace("${record_id}", result.data.record_id + redirectStr.value)) !== null && _paymentMethodValue$s !== void 0 ? _paymentMethodValue$s : "";
                cancel_url = (_paymentMethodValue$c = (_paymentMethodValue$c2 = paymentMethodValue.cancel_url) === null || _paymentMethodValue$c2 === void 0 ? void 0 : _paymentMethodValue$c2.replace("${record_id}", result.data.record_id + redirectStr.value)) !== null && _paymentMethodValue$c !== void 0 ? _paymentMethodValue$c : "";
                successUrl = paymentMethodValue.needRedirect ? "".concat(process.env.VUE_APP_PAYMENT_API_URI, "/payment/v1/callback/redirection?url=").concat(success_url) : success_url;
                cancelUrl = paymentMethodValue.needRedirect ? "".concat(process.env.VUE_APP_PAYMENT_API_URI, "/payment/v1/callback/redirection?url=").concat(cancel_url) : cancel_url;
                createOnlinePay({
                  srv: createRechargeOnlinePayment,
                  orderId: result.data.record_id,
                  paymentChannel: paymentMethodValue,
                  successUrl: successUrl,
                  cancelUrl: cancelUrl,
                  onSuccess: function onSuccess() {
                    cartStore.setCartStorage();
                  },
                  onError: function onError() {
                    showToast(t("createOnlinePayFailed"));
                  },
                  redirectOrderDetailUrl: "#/recharge?id=".concat(result.data.record_id, "&callback=1"),
                  shopname: shopStore.getShopName,
                  paymentshubPayPageUrl: process.env.VUE_APP_PAYMENTSHUB_PAY_PAGE_URL,
                  paymentshubRedirectUrl: process.env.VUE_APP_PAYMENTSHUB_REDIRECT_URL
                });
              } else {
                hideLoading();
                if (result.code === SHOP_UNSUPPORT_DELIVERY) {
                  handleShowOrderFailTips(t("thisShopDoesUnsupportDelivery"));
                } else if (result.code === SHOP_BUSY) {
                  handleShowOrderFailTips(t("shopBusyDesc"));
                } else if (result.code === SHOP_NOT_IN_BUSINESS_STATUS) {
                  handleShowOrderFailTips(t("storeIsNotInBusinessStatus"));
                } else if (result.code === DISHES_ORDER_ITEM_INVALID) {
                  failDishesStr = (((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.failed_dishes_items) || []).map(function (item) {
                    return item.name;
                  }).join(", ");
                  handleShowOrderFailTips(t("xIsTemporarilyNotAvailable", [failDishesStr]));
                } else {
                  showToast(t("orderFailed"));
                }
              }
              _context3.next = 20;
              break;
            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](8);
              console.error(_context3.t0);
              hideLoading();
              showToast(t("orderFailed"));
            case 20:
              isSubmit.value = false;
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[8, 15]]);
      }));
      return _handleRecharge.apply(this, arguments);
    }
    var handleCheckId = ref(0);
    var timer = ref(null);
    var curTime = ref(0);
    var showNotCompletePopup = ref(false);
    var paymentResultMap = ref({
      PAID: "paid",
      // 支付成功
      UNPAID: "unpaid",
      // 未完成支付
      CABCELLED: "cancelled",
      // 已取消
      FAILED: "failed" // 已失败
    });
    var isNotPayYet = ref(false);
    function simpleCountDown(time) {
      timer.value && clearTimeout(timer.value);
      if (time < 0) {
        return;
      }
      curTime.value = time;
      timer.value = setTimeout(function () {
        simpleCountDown(time - 1);
      }, 1000);
    }
    function handleCheck() {
      // 更新handleCheckId
      var handleCheckIdValue = handleCheckId.value;
      var curHandleCheckId = handleCheckId.value = handleCheckIdValue + 1;
      showLoading(t("checking"));
      simpleCountDown(3);
      var _checkOnlinePayment = function checkOnlinePayment() {
        setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var res;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return checkRechargeOrder({
                  record_id: recordId.value
                });
              case 2:
                res = _context2.sent;
                if (curHandleCheckId === handleCheckId.value && res.isOK && res.data) {
                  if (res.data.payment_status === paymentResultMap.value.PAID) {
                    curHandleCheckId = 0;
                    hideLoading();
                    Notify.success(t("orderedSuccessful"));
                    // let routerRedirectParams;
                    // switch (redirectType.value) {
                    //   case "order_detail":
                    //     routerRedirectParams = {
                    //       name: "OrderDetail",
                    //       query: {
                    //         id: routes.query.order_id,
                    //       },
                    //     };
                    //     break;
                    //   case "confirm_order":
                    //     routerRedirectParams = {
                    //       name: "ConfirmOrder",
                    //     };
                    //     break;
                    //   default:
                    //     routerRedirectParams = {
                    //       name: "MyBalance",
                    //     };
                    //     break;
                    // }
                    setTimeout(function () {
                      // 是不是用replace会好点?
                      // routerPush(routerRedirectParams);
                      window.location.replace("".concat(window.location.origin).concat(window.location.pathname).concat(window.location.search, "#/recharge"));
                      var toUrl;
                      switch (redirectType.value) {
                        case "order_detail":
                          toUrl = "".concat(window.location.origin).concat(window.location.pathname).concat(window.location.search, "#/order_detail?id=").concat(routes.query.order_id, "&back_to_orders=1");
                          break;
                        case "confirm_order":
                          toUrl = "".concat(window.location.origin).concat(window.location.pathname).concat(window.location.search, "#/confirm_order?back_to_menu=1");
                          break;
                        default:
                          toUrl = "".concat(window.location.origin).concat(window.location.pathname).concat(window.location.search, "#/my_balance?back_to_account=1");
                          break;
                      }
                      window.location.assign(toUrl);
                    }, 1000);
                  } else if (res.data.payment_status === paymentResultMap.value.FAILED) {
                    curHandleCheckId = 0;
                    hideLoading();
                    Notify.error(t("paymentFailed"));
                    isNotPayYet.value = true;
                    // payFailReason.value = res.data.fail_reason;
                  } else {
                    if (curTime.value === 0) {
                      curHandleCheckId = 0;
                      hideLoading();
                      showNotCompletePopup.value = true;
                    } else {
                      _checkOnlinePayment();
                    }
                  }
                } else {
                  curHandleCheckId = 0;
                  hideLoading();
                  showNotCompletePopup.value = true;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })), 500);
      };
      _checkOnlinePayment();

      // 倒计时结束，查询仍未结束
      setTimeout(function () {
        if (curHandleCheckId === handleCheckId.value) {
          curHandleCheckId = 0;
          hideLoading();
          showNotCompletePopup.value = true;
        }
      }, 3000);
    }
    function onClickNotPay() {
      showNotCompletePopup.value = false;
      isNotPayYet.value = true;
    }
    function onClickHavePaid() {
      showNotCompletePopup.value = false;
      handleCheck();
    }
    onMounted(function () {
      var cartStorageData = cartStore.getCartStorage();
      if (cartStorageData) {
        if (cartStorageData.shop_id === shopStore.getShopId && cartStorageData.cart) {
          cartStore.setCart(cartStorageData.cart);
        }
        cartStore.removeCartStorage();
      }
      if (routes.query.callback && routes.query.id) {
        handleCheck();
        queryRule(false);
      } else {
        queryRule();
      }
    });
    return function (_ctx, _cache) {
      var _component_SvgIcon = _resolveComponent("SvgIcon");
      var _component_Gap = _resolveComponent("Gap");
      var _component_Button = _resolveComponent("Button");
      var _component_Page = _resolveComponent("Page");
      return _openBlock(), _createBlock(_component_Page, {
        title: _ctx.$t('reload'),
        class: "recharge-page-wrap",
        "show-footer": true,
        "is-yellow-bg": ""
      }, {
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("balance")), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice(_unref(userStore).getWallet, _unref(userStore).getWalletCurrency)), 1)]), _createVNode(_component_Button, {
            type: "content",
            class: "recharge-footer-btn",
            disabled: isSubmitButtonDisabled.value,
            onClick: handleRecharge
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(submitButtonText.value), 1)];
            }),
            _: 1
          }, 8, ["disabled"])])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("reloadItems")), 1), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rechargeRuleList.value, function (rule) {
            return _openBlock(), _createElementBlock("div", {
              key: rule.id,
              class: _normalizeClass(["item", {
                'item-active': rule.id === curSelectedRule.value.id
              }]),
              onClick: function onClick($event) {
                return handleSelectRechargeRule(rule);
              }
            }, [_createVNode(_component_SvgIcon, {
              name: "selected_mark",
              size: 24,
              class: "selected-mark"
            }), _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(priceUtil).formatBaseUnitToShowPrice(rule.amount, rule.currency, true, 0)), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(getRuleRewardStr(rule)), 1), getIsRuleCanViewDetail(rule) ? (_openBlock(), _createBlock(_component_SvgIcon, {
              key: 0,
              name: "search",
              size: 16,
              class: "search-icon",
              onClick: _withModifiers(function ($event) {
                return handleCallRewardDetail(rule);
              }, ["stop"])
            }, null, 8, ["onClick"])) : _createCommentVNode("", true)])], 10, _hoisted_5);
          }), 128))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("reloadIntroduction")), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(ruleDescShow.value), 1)])]), _createVNode(_component_Gap, {
            h: 0.1
          }), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("paymentMethods")), 1), _createElementVNode("div", _hoisted_14, [_createVNode(PaymentMethodVue, {
            ref_key: "paymentMethodRef",
            ref: paymentMethodRef,
            "delivery-method": deliveryMethod.value,
            "use-type": "recharge",
            onChange: handleSelectPaymentMethod
          }, null, 8, ["delivery-method"])])])]), _createVNode(_unref(RechargeRuleRewardPopup), {
            show: isRechargeRuleRewardPopupShow.value,
            "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
              return isRechargeRuleRewardPopupShow.value = $event;
            }),
            "reward-list": viewDetailRewardList.value,
            currency: viewDetailCurrency.value
          }, null, 8, ["show", "reward-list", "currency"]), _createVNode(Common, {
            visible: showNotCompletePopup.value,
            "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
              return showNotCompletePopup.value = $event;
            }),
            title: _ctx.$t('resultChecking'),
            desc: _ctx.$t('didYouFinishThePayment'),
            "ok-text": _ctx.$t('yes'),
            "cancel-text": _ctx.$t('noYet'),
            "on-cancel": onClickNotPay,
            "on-ok": onClickHavePaid,
            "cancel-on-click-overlay": true,
            "hide-bottom-shadow": true
          }, null, 8, ["visible", "title", "desc", "ok-text", "cancel-text"])];
        }),
        _: 1
      }, 8, ["title"]);
    };
  }
};